// removed by extract-text-webpack-plugin
module.exports = {"title":"PopinVinInfo-module-title-2O3qn","description":"PopinVinInfo-module-description-3OwHK","img":"PopinVinInfo-module-img-jGyF9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopinVinInfo/PopinVinInfo.module.scss
// module id = 1032
// module chunks = 0